import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState } from "preact/hooks"

export default function ({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id);
    const isSelected = min !== range[0] || max !== range[1];
    const [ active, setActive ] = useState(isSelected);

    return (
        <div class={`ns-sidebar-dropdown relative text-left m-0 ${active ? "ns-active" : ""}`}>
            <div class="ns-sidebar-dropdown-header relative overflow-visible p-0">
                <button
                    class="facet-toggle block relative text-left w-full mb-0 pb-0 "
                    data-nosto-element="facet"
                    type="button"
                    label={`Filter product by ${facet.name}`}
                    aria-controls={`nosto-filter-${facet.field}`}
                    aria-expanded={active ? "true" : "false"}
                    tabIndex="0"
                    onClick={() => {
                        setActive(prevActive => !prevActive)
                    }}
                >
                    <span class="block ns-facet-name uppercase leading-6 not-italic font-semibold cursor-pointer">{facet.name}</span>
                </button>
            </div>
            
            <div class={`ns-sidebar-submenu range w-full text-left whitespace-normal p-0 m-0 lg:block ${active ? "block" : "hidden"}`} id={`nosto-filter-${facet.field}`}>
                <div class="ns-sidebar-submenu-inner w-full mt-3">

                    <div class="ns-range-input-wrapper flex gap-2 justify-between">
                        <div class="relative w-1/2">
                            <label for={`ns-${facet.id}-min`} class="ns-range-label">
                                Min.
                            </label>
                            <input
                                type="number"
                                class="ns-range-input w-full"
                                id={`ns-${facet.id}-min`}
                                value={range[0]}
                                min={min}
                                max={max}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([value, range[1]])
                                }}
                            />
                        </div>
                        <div class="relative w-1/2">
                            <label for={`ns-${facet.id}-max`} class="ns-range-label">
                                Max.
                            </label>
                            <input
                                type="number"
                                class="ns-range-input w-full"
                                id={`ns-${facet.id}-max`}
                                value={range[1]}
                                min={min}
                                max={max}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([range[0], value])
                                }}
                            />
                        </div>
                    </div>
                    <RangeSlider id={facet.id} />
                </div>
            </div>
        </div>
    )
}
